import { render } from "./PointPropertyControl.vue?vue&type=template&id=69aa3c76&scoped=true"
import script from "./PointPropertyControl.vue?vue&type=script&lang=js"
export * from "./PointPropertyControl.vue?vue&type=script&lang=js"

import "./PointPropertyControl.vue?vue&type=style&index=0&id=69aa3c76&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69aa3c76"]])

export default __exports__